<ng-container *ngIf="isLoading">
    <div class="fixed w-full h-full left-0 top-0 flex justify-center items-center bg-blue-800/40">
        <div class="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </div>
</ng-container>